/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * A type representing state machine states. It is an alias of string and used to make API signatures clearer.
 *
 * @remarks
 *
 * In the future this may become a string enum.
 */
export type MachineState = string;
